import gql from 'graphql-tag'
export const GET_CONTENT = gql `
  query conteudo($id: String!) {
    conteudo(_id: $id) {
        codigo,
        professor,
        descricao,
        titulo,
        subtipo,
        tipo,
        url,
        conteudo_id,
        perguntas {
          _id
          enunciado
          dificuldade {
            label
          }
          prova {
            descricao
            ano
            instituicao {
              nome
            }
          }
          respostas {
            _id
            numero
            resposta
          }
        }
    }
  }
`